module.exports = __webpack_public_path__ + "img/res_win.4ab286a4.png";